<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0, viewport-fit=cover, interactive-widget=resizes-content"
    />
    <title>Altto Control</title>
    <meta name="color-scheme" content="dark light" />
    <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32.png" />
    <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    <link rel="manifest" href="/manifest.webmanifest" />
    <script>
      (function () {
        // Family names renamed 2026-07-19 (AV2 R4): claw->nova, knot->eclipse,
        // dash->orbit. FAMILY_ALIAS carries forward settings blobs written by
        // the pre-rename build (theme+themeMode stored separately, mode intact).
        // LEGACY carries forward the even-older flat/fused format that predates
        // the family system entirely (theme alone implied both family+mode).
        var THEMES = { nova: 1, eclipse: 1, orbit: 1 };
        var MODES = { system: 1, light: 1, dark: 1 };
        var FAMILY_ALIAS = { claw: "nova", knot: "eclipse", dash: "orbit" };
        var LEGACY = {
          dark: "nova:dark",
          light: "nova:light",
          openknot: "eclipse:dark",
          fieldmanual: "orbit:dark",
          clawdash: "orbit:light",
          system: "nova:system",
        };
        try {
          var keys = Object.keys(localStorage);
          var raw;
          for (var i = 0; i < keys.length; i++) {
            if (keys[i].indexOf("altto.control.settings.v1") === 0) {
              raw = localStorage.getItem(keys[i]);
              if (raw) break;
            }
          }
          if (!raw) return;
          var s = JSON.parse(raw);
          var t = s && s.theme;
          var m = s && s.themeMode;
          if (typeof t !== "string") t = "";
          if (typeof m !== "string") m = "";
          if (FAMILY_ALIAS[t]) t = FAMILY_ALIAS[t];
          var legacy = LEGACY[t];
          var theme = THEMES[t] ? t : legacy ? legacy.split(":")[0] : "nova";
          var mode = MODES[m] ? m : legacy ? legacy.split(":")[1] : "system";
          if (mode === "system") {
            mode = window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
          }
          var resolved =
            theme === "eclipse"
              ? mode === "light"
                ? "openknot-light"
                : "openknot"
              : theme === "orbit"
                ? mode === "light"
                  ? "dash-light"
                  : "dash"
                : mode === "light"
                  ? "light"
                  : "dark";
          document.documentElement.setAttribute("data-theme", resolved);
          document.documentElement.setAttribute(
            "data-theme-mode",
            resolved.includes("light") ? "light" : "dark",
          );
        } catch (e) {}
      })();
    </script>
    <style>
      body.altto-mount-fallback-active {
        margin: 0;
        min-width: 320px;
        color: #eef4f8;
        background: #101418;
        font-family:
          Inter,
          ui-sans-serif,
          system-ui,
          -apple-system,
          BlinkMacSystemFont,
          "Segoe UI",
          sans-serif;
      }

      body.altto-mount-fallback-active altto-app {
        display: none;
      }

      .mount-fallback {
        box-sizing: border-box;
        /* The app stylesheet clips the root scrollers, so this pre-app error
           surface must own its scrolling on short windows. dvh keeps the
           scroll range inside the visible mobile viewport; vh is the fallback. */
        height: 100vh;
        height: 100dvh;
        overflow-y: auto;
        padding: 24px;
        place-items: center;
        place-items: safe center;
      }

      .mount-fallback:not([hidden]) {
        display: grid;
      }

      .mount-fallback__panel {
        box-sizing: border-box;
        width: min(100%, 640px);
        border: 1px solid rgba(148, 163, 184, 0.28);
        border-radius: 8px;
        background: #151b21;
        box-shadow: 0 24px 80px rgba(0, 0, 0, 0.36);
        padding: 28px;
      }

      .mount-fallback__eyebrow {
        margin: 0 0 10px;
        color: #9fb0bd;
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
      }

      .mount-fallback__panel h1 {
        margin: 0;
        color: inherit;
        font-size: clamp(1.5rem, 3vw, 2rem);
        line-height: 1.15;
      }

      .mount-fallback__panel p {
        margin: 16px 0 0;
        color: #c8d3da;
        font-size: 1rem;
        line-height: 1.6;
      }

      .mount-fallback__panel ul {
        margin: 18px 0 0;
        padding-left: 1.2rem;
        color: #c8d3da;
        line-height: 1.6;
      }

      .mount-fallback__panel a {
        color: #8bd3ff;
        text-decoration-thickness: 0.08em;
        text-underline-offset: 0.18em;
      }

      .mount-fallback__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 24px;
      }

      .mount-fallback__button {
        min-height: 42px;
        border: 1px solid rgba(148, 163, 184, 0.36);
        border-radius: 6px;
        padding: 0 16px;
        color: inherit;
        background: transparent;
        font: inherit;
        font-weight: 700;
      }

      .mount-fallback__button--primary {
        border-color: #66c2ff;
        color: #061019;
        background: #8bd3ff;
      }

      .mount-fallback__panel:focus {
        outline: none;
      }

      .mount-fallback__button:focus-visible,
      .mount-fallback__panel a:focus-visible {
        outline: 3px solid #f9c74f;
        outline-offset: 3px;
      }

      html[data-theme-mode="light"] body.altto-mount-fallback-active {
        color: #151b21;
        background: #f5f7fa;
      }

      html[data-theme-mode="light"] .mount-fallback__panel {
        border-color: rgba(71, 85, 105, 0.22);
        background: #ffffff;
        box-shadow: 0 24px 80px rgba(15, 23, 42, 0.14);
      }

      html[data-theme-mode="light"] .mount-fallback__eyebrow,
      html[data-theme-mode="light"] .mount-fallback__panel p,
      html[data-theme-mode="light"] .mount-fallback__panel ul {
        color: #4b5963;
      }

      html[data-theme-mode="light"] .mount-fallback__panel a {
        color: #0369a1;
      }
    </style>
  </head>
  <body>
    <altto-app></altto-app>
    <section
      id="altto-mount-fallback"
      class="mount-fallback"
      data-altto-mount-timeout-ms="12000"
      role="alert"
      aria-labelledby="altto-mount-fallback-title"
      hidden
    >
      <div class="mount-fallback__panel" tabindex="-1">
        <p class="mount-fallback__eyebrow">Altto Control UI</p>
        <h1 id="altto-mount-fallback-title">Control UI did not start</h1>
        <p id="altto-mount-fallback-summary">
          The browser loaded the static page, but the app bundle did not start. The gateway may be
          restarting, or this page may reference assets from a different Altto version.
        </p>
        <ul>
          <li>Altto will retry the current app bundle automatically.</li>
          <li>If this persists, reload or try a clean browser profile.</li>
          <li>
            See
            <a
              href="https://docs.altto.ai/web/control-ui#blank-control-ui-page"
              target="_blank"
              rel="noopener noreferrer"
              >Control UI troubleshooting</a
            >.
          </li>
        </ul>
        <div class="mount-fallback__actions">
          <button
            type="button"
            id="altto-mount-retry"
            class="mount-fallback__button mount-fallback__button--primary"
          >
            Try again
          </button>
          <button type="button" id="altto-mount-wait" class="mount-fallback__button">
            Keep waiting
          </button>
        </div>
      </div>
    </section>
    <script>
      (function () {
        var tagName = "altto-app";
        var app = document.querySelector(tagName);
        var fallback = document.getElementById("altto-mount-fallback");
        if (!app || !fallback) return;

        var panel = fallback.querySelector(".mount-fallback__panel");
        var summary = document.getElementById("altto-mount-fallback-summary");
        var retry = document.getElementById("altto-mount-retry");
        var wait = document.getElementById("altto-mount-wait");
        var rawDelay = Number(fallback.getAttribute("data-altto-mount-timeout-ms"));
        var delay = Number.isFinite(rawDelay) && rawDelay > 0 ? rawDelay : 12000;
        var maxRecoveryAttempts = 6;
        var timer;
        var recoveryTimer;
        var recoveryAttempt = 0;
        var recoveryInFlight = false;
        var recoveryNavigation = false;

        try {
          var initialUrl = new URL(window.location.href);
          recoveryNavigation = initialUrl.searchParams.has("altto_mount_recovery");
          if (recoveryNavigation) {
            initialUrl.searchParams.delete("altto_mount_recovery");
            window.history.replaceState(null, "", initialUrl.href);
          }
        } catch (e) {}

        function appMounted() {
          try {
            return Boolean(
              app.isConnected &&
              window.customElements &&
              typeof window.customElements.get === "function" &&
              window.customElements.get(tagName),
            );
          } catch (e) {
            return false;
          }
        }

        function hideFallback() {
          fallback.hidden = true;
          document.body.classList.remove("altto-mount-fallback-active");
        }

        function setSummary(text) {
          if (summary) summary.textContent = text;
        }

        function scheduleRecovery() {
          window.clearTimeout(recoveryTimer);
          if (appMounted() || recoveryAttempt >= maxRecoveryAttempts) return;
          var retryDelay = Math.min(delay, 1000 * Math.pow(2, recoveryAttempt));
          recoveryTimer = window.setTimeout(retryCurrentDocument, retryDelay);
        }

        function finishRecoveryAttempt() {
          recoveryInFlight = false;
          if (appMounted()) return;
          if (recoveryAttempt >= maxRecoveryAttempts) {
            setSummary(
              "The gateway is still unavailable. Try again, then check the troubleshooting guide if the problem persists.",
            );
            return;
          }
          setSummary(
            "The gateway is not reachable yet. Altto will keep retrying while it restarts.",
          );
          scheduleRecovery();
        }

        function retryCurrentDocument() {
          if (
            appMounted() ||
            recoveryInFlight ||
            recoveryAttempt >= maxRecoveryAttempts ||
            typeof window.fetch !== "function"
          )
            return;
          var documentUrl = new URL(window.location.href);
          if (recoveryNavigation) {
            setSummary(
              "A fresh page still could not start the Control UI. Try again, then check the troubleshooting guide if the problem persists.",
            );
            return;
          }
          recoveryInFlight = true;
          recoveryAttempt += 1;
          documentUrl.searchParams.set("altto_mount_recovery", String(Date.now()));
          window
            .fetch(documentUrl.href, { cache: "no-store", credentials: "same-origin" })
            .then(function (response) {
              if (!response.ok) throw new Error("gateway unavailable");
              window.location.replace(documentUrl.href);
            })
            .catch(function () {
              finishRecoveryAttempt();
            });
        }

        function showFallback() {
          if (appMounted()) return;
          retryCurrentDocument();
          fallback.hidden = false;
          document.body.classList.add("altto-mount-fallback-active");
          if (panel && typeof panel.focus === "function") {
            try {
              panel.focus({ preventScroll: true });
            } catch (e) {
              panel.focus();
            }
          }
        }

        function armFallbackTimer() {
          window.clearTimeout(timer);
          timer = window.setTimeout(showFallback, delay);
        }

        armFallbackTimer();

        if (window.customElements && typeof window.customElements.whenDefined === "function") {
          window.customElements.whenDefined(tagName).then(
            function () {
              window.clearTimeout(timer);
              window.clearTimeout(recoveryTimer);
              hideFallback();
            },
            function () {},
          );
        }

        if (retry) {
          retry.addEventListener("click", function () {
            window.location.reload();
          });
        }
        if (wait) {
          wait.addEventListener("click", function () {
            hideFallback();
            recoveryAttempt = 0;
            retryCurrentDocument();
            armFallbackTimer();
          });
        }
      })();
    </script>
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
